import type { IconType } from 'react-icons'
import type { IconBaseProps } from 'react-icons'
import { IconBase } from 'react-icons'

export const Databricks: IconType = (props: IconBaseProps) => (
  <IconBase {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.950195 14.184L12.0002 20.403L21.9192 14.853V17.063L12.0002 22.662L1.5162 16.702L0.951195 17.01V17.78L12.0002 24L23.0502 17.782V13.465L22.5352 13.156L12.0002 19.118L2.13319 13.465V11.255L12.0002 16.805L23.0502 10.587V6.32L22.5352 6.012L12.0002 11.974L2.64719 6.681L12.0002 1.388L19.7602 5.756L20.4282 5.345V4.779L12.0002 0L0.950195 6.27V6.99L12.0002 13.207L21.9192 7.657V9.917L12.0002 15.52L1.5162 9.56L0.951195 9.868L0.950195 14.184Z"
        fill="#383D48"
      />
    </svg>
  </IconBase>
)
